export class Page {

  constructor(public id: number,
              public name: string,
              public created_at: string,
              public body: string,
              public parent: number,
              public previous: number,
              public next: number,
              public children: Page[]) {
  }
}

